import { mapArrayElement } from "../../common";
function mapMarketType(data) {
    return {
        id: data[0],
        betOfferTypeId: data[1],
        name: data[2]
    };
}
function buildStatistic(data) {
    return data.map((statistic) => ({
        type: statistic[0],
        prefix: statistic[1],
        value: statistic[2],
    }));
}
function buildStatistics(data) {
    return {
        live: mapArrayElement(data[0], buildStatistic),
    };
}
export function mapStatistics(data) {
    return mapArrayElement(data, buildStatistics);
}
export function mapSportsbookMarketsUpdate(data) {
    return {
        id: data[0],
        name: data[1],
        isSuspended: data[2],
        tags: data[3],
        sortOrder: data[4],
        statistics: mapStatistics(data[5]),
    };
}
export function mapSportsbookMarket(data) {
    return {
        id: data[0],
        eventId: data[1],
        sportId: data[2],
        leagueId: data[3],
        name: data[4],
        isSuspended: data[5],
        subcategoryId: data[6],
        marketType: mapMarketType(data[7]),
        tags: data[8],
        sortOrder: data[9],
        statistics: mapStatistics(data[10]),
        correlatedId: data[11]
    };
}
//# sourceMappingURL=mapSportsbookMarket.js.map